import { createAction, props } from '@ngrx/store'
import { SharedConfig } from '../../shared/shared.config';

export const SET_APP_ID = 'SET_APP_ID'
export const SET_SHARED_CONFIG = 'SET_APP_CONFIG'

export const setAppId = createAction(SET_APP_ID, props<{ payload: string }>())

export const setSharedConfig = createAction(SET_SHARED_CONFIG, props<{ payload: SharedConfig }>())
